import CampaignsAllAdmin from './CampaignsAllAdmin';
export default CampaignsAllAdmin;
